module.exports = __webpack_public_path__ + "img/skip-backward-circle.01744d66.svg";